"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _HightRiskChartWithLabelComponent = _interopRequireDefault(require("../../HightRiskChart/HightRiskChartWithLabelComponent"));
var _AccountSummaryBox = require("./AccountSummaryBox");
require("./AccountSummaryComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('wallets-account-summary');
var MarginAccountSummaryComponent = function MarginAccountSummaryComponent(_ref) {
  var baseAsset = _ref.baseAsset,
    summary = _ref.summary,
    marginAccount = _ref.marginAccount,
    getMarginAccountInfo = _ref.getMarginAccountInfo,
    riskLevel = _ref.riskLevel;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    if (marginAccount !== null && marginAccount !== void 0 && marginAccount.AccountId) {
      getMarginAccountInfo(marginAccount.AccountId);
    }
  }, [marginAccount === null || marginAccount === void 0 ? void 0 : marginAccount.AccountId, getMarginAccountInfo]);
  var formatValue = function formatValue(value) {
    return isNaN(value) || value === undefined ? value : (0, _numberFormatter.formatNumberToLocale)(value, baseAsset.DecimalPlaces);
  };
  var baseAssetSymbol = baseAsset.Product;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('component', 'margin')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('left-section')
  }, /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Total Balance ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.Balance)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-labelledby": "afterHaircutsLabel"
  }, formatValue(summary.MarginBalance)), ' ', /*#__PURE__*/_react["default"].createElement("label", {
    id: "afterHaircutsLabel"
  }, t('After Haircuts'))), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t("Today's P&L"),
    value: "".concat(formatValue(summary.PnLPercentage), "%")
  }, formatValue(summary.PnLValue), " ", baseAssetSymbol), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Liability ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.Liability)
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t("Risk Level (0-100)"),
    className: 'risk-level-box'
  }, (riskLevel === null || riskLevel === void 0 ? void 0 : riskLevel.label) && /*#__PURE__*/_react["default"].createElement(_HightRiskChartWithLabelComponent["default"], {
    level: riskLevel.level,
    riskNumber: riskLevel.riskNumber,
    label: riskLevel.label
  })), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Margin Equity ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.MarginEquity)
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Maintenance Thres. ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.MaintenanceRequirement)
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Used Margin ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.UsedMarginValue)
  }), /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Usable Margin ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.UsableMarginValue)
  })));
};
var _default = exports["default"] = MarginAccountSummaryComponent;